import React from "react"

function Trophy({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      fill={fill}
      viewBox="6 6 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0513 8.57031H7.3147V9.91581C7.31526 11.5347 8.51282 12.9033 10.1171 13.1187L10.1182 13.1192"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.934 8.57021H28.6706V9.91571C28.67 11.5346 27.4724 12.9031 25.8682 13.1186L25.8671 13.1191"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1008 9.80713V13.5539C15.1008 14.8578 15.9794 15.9974 17.24 16.3288C17.5325 16.385 17.8424 16.4238 18.1726 16.4328"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0335 7.12207H23.6581V13.7489C23.6581 14.6073 23.4562 15.4533 23.0686 16.2194C21.137 20.0382 15.5311 20.5287 13.0061 16.6413C12.3806 15.6664 12.0476 14.5324 12.0476 13.3743C12.0346 11.4049 12.0335 7.12207 12.0335 7.12207Z"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9162 21.3057C15.725 24.1519 20.2188 24.2892 19.9353 21.3057"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4333 28.3652H24.3466"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8903 28.3669V23.7061"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Trophy
